import { render, staticRenderFns } from "./ProposalStatusLines.vue?vue&type=template&id=6b1498b8&"
import script from "./ProposalStatusLines.vue?vue&type=script&lang=js&"
export * from "./ProposalStatusLines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
installComponents(component, {VAlert})
